module.exports = __webpack_public_path__ + "static/media/cluster-terminology-1.9a560ea6.jpg";